<div adaptToolbarContent>
    <button adaptButton="tour"
            data-test="tour-run"
            (click)="runTour()"></button>
</div>

<div adaptToolbarContent
     [ordinal]="1000">
    <a [routerLink]="personalConfigLink$ | async"
       adaptButton="configureLink"
       adaptTooltip="Go to personal configuration"></a>
</div>

<adapt-activity-page-content class="h-100"></adapt-activity-page-content>
